module.exports = __webpack_public_path__ + "img/building-solid.fe4f460.svg";